module.exports = __webpack_public_path__ + "img/slide2-cyberteck-desktop.66eeaad9.png";